import Todo from "./Todo";

function App() {
  return (
    <div className="container">
      <Todo />
    </div>
  );
}

export default App;
